/** @jsxImportSource @emotion/react */
import { Plural } from '@lingui/react/macro';
import type { BestScorer } from 'modules/main/domain/types/types';
import RankedBarList from 'modules/main/ui/components/section/components/ranked-bar-list/ranked-bar-list';
import React from 'react';
import type { DivProps } from 'typings';

interface IScorersProps extends DivProps {
  scorers: BestScorer[];
}

function Scorers(props: IScorersProps) {
  const { scorers, ...rest } = props;

  const items = scorers.map((scorer) => {
    const nameParts = scorer.name.split(' ');
    const name = nameParts[1] ? `${nameParts[0]} ${nameParts[1][0]}.` : nameParts[0];

    return {
      id: scorer.id,
      image: scorer.image,
      label: name,
      value: scorer.goals,
      valueText: <Plural value={scorer.goals} one="# гол" few="# гола" many="# голов" other="# гола" />,
    };
  });

  return <RankedBarList items={items} {...rest} />;
}

export default Scorers;
